<template>
  <div class="app-inner">
<!--    合同内容-->
    <div style="width: 12rem;">
      <div class="ql-editor" v-html="content"></div>
      <br />
      <div class="title" style="width: 2.5rem;margin: 0 auto;">《租金价目表》（人民币）</div>
      <el-table
          v-loading="loading"
          :data="previewTableData"
          border
          :default-sort = "{prop: 'id', order: 'descending'}"
          :highlight-current-row="false">
        <template v-for="(item, index) in previewTableColumns">
          <el-table-column
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width">
          </el-table-column>
        </template>
      </el-table>
      <div class="content">
        <div class="word">1.本价目表中的租金总额以租赁面积 {{contractRentalRelationArea}} 平方米为前提计算。租金计算公式为房屋建筑面积*日租金*365天。</div>
        <div class="word">2.本价目表信息一经提交，无法修改，请慎重计算！</div>
      </div>
    </div>
    <!--      列表-->
    <div class="table">
      <p style="font-size: large;font-weight:600;line-height: .6rem">审核流程</p>
      <div class="searchList">
        <el-table
            v-loading="loading"
            :data="tableData"
            :default-sort = "{prop: 'id', order: 'descending'}"
            style="width: 100%"
            :highlight-current-row="false"
            :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
          <template v-for="(item, index) in tableColumns">
            <el-table-column
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width">
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>
    <div class="btnDiv">
      <el-button class="searchBtn" type="primary" @click="goback">返 回</el-button>
      <el-button class="searchBtn" v-if="roleName === '招商员'" style="margin-left: .4rem" type="primary" @click="submit">提 交</el-button>
      <el-button class="searchBtn" v-else-if="roleName !== '招商员' && roleName !== '管理员'" style="margin-left: .4rem" type="primary" @click="approval">审 批</el-button>
    </div>
    <div class="dialogDiv">
<!--      审批弹框-->
      <el-dialog title="审批" center :visible.sync="approvalDialogVisible" :modal-append-to-body='false'>
        <div style="margin-bottom: .2rem">
          <span style="margin-right: .2rem">审批结果:</span>
          <el-radio v-model="approved" :label="true">同意</el-radio>
          <el-radio v-model="approved" :label="false">驳回</el-radio>
        </div>
        <span style="margin-right: .2rem">审批意见:</span>
        <el-input
            type="textarea"
            style="width: 65%;vertical-align:top;"
            :autosize="{ minRows: 3, maxRows: 5}"
            placeholder="请输入内容"
            v-model="approvalText">
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button class="searchBtn" @click="approvalDialogVisible = false">取 消</el-button>
          <el-button class="searchBtn" type="primary" @click="approvalFun()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!--    提交(招商员) 弹框-->
    <div class="dialogDiv">
      <el-dialog
          title="提交"
          :visible.sync="submitVisible"
          center>
        <span>提交意见:</span>
        <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5}"
            placeholder="请输入内容"
            v-model="submitText">
        </el-input>
        <div slot="footer" class="dialog-footer">
          <el-button @click="submitVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitEvent()">确 认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { addContractApprove, previewContractDetail } from '@/api/contract'
import base from '@/utils/index'
import { Message } from 'element-ui'

export default {
  name: 'approvalOpinion',
  components: {},
  data () {
    return {
      loading: false,
      // currentPage: 1,
      // totalCount: 0,
      // pageSize: 10,
      approvalDialogVisible: false,
      submitVisible: false,
      rejectText: '',
      approvalText: '',
      submitText: '',
      approved: undefined,
      id: this.$route.query.id,
      contractNumber: this.$route.query.contractNumber,
      roleName: '',
      tableColumns: [
        {
          prop: 'roleName',
          label: '处理角色'
        },
        {
          prop: 'createUser',
          label: '处理人'
        },
        {
          prop: 'processRemark',
          label: '提交意见'
        },
        {
          prop: 'createTime',
          label: '时间'
        }
      ],
      tableData: [],
      // 预览的表格数据
      previewTableData: [],
      previewTableColumns: [
        // {
        //   prop: 'id',
        //   label: '项目'
        // },
        {
          prop: 'rentalDate',
          label: '租赁期限',
          width: '200px'

        },
        {
          prop: 'rentalUnit',
          label: '每期租金（元）'
        },
        {
          prop: 'rentalSum',
          label: '租金总额（元）'
        },
        {
          prop: 'dailyRental',
          label: '日租金（元/天/平米）'
        },
        // {
        //   prop: 'manageFee',
        //   label: '物业管理费（元）'
        // },
        {
          prop: 'remark',
          label: '备注'
        }
      ],
      contractRentalRelationArea: '', // 预览最后的租赁面积参数
      content: '' // 预览内容
    }
  },
  mounted () {
    this.getData()
    const baseFunc = base()
    this.roleName = baseFunc.getLocalStorage('userInfo_roleName')
  },
  methods: {
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryList()
    },
    getData () {
      this.currentPage = 1
      this.queryList()
    },
    async queryList () {
      let res = await previewContractDetail({
        id: this.id
      })
      if (res.code === 0) {
        let previewTableDataNew = []
        this.content = res.result.contractFormatContent
        res.result.contractRentalRelationList.forEach((item) => {
          previewTableDataNew.push({
            id: item.id,
            rentalDate: item.rentalStartDate + ' -- ' + item.rentalEndDate,
            rentalUnit: item.rentalUnit,
            rentalSum: item.rentalSum,
            dailyRental: item.dailyRental,
            manageFee: item.manageFee,
            remark: item.remark
          })
        })
        this.previewTableData = previewTableDataNew
        this.contractRentalRelationArea = res.result.contractRentalRelationArea
        // this.tableData = res.result.contractProcessEntityList
        this.tableData = res.result.contractProcessPrintMixInfoList
      }
    },
    goback () {
      this.$router.go(-1)
    },
    approval () {
      this.approvalDialogVisible = true
    },
    submit () {
      this.submitVisible = true
    },
    // 提交接口（招商员）
    async submitEvent () {
      let res = await addContractApprove({
        approved: true,
        contractNumber: this.contractNumber,
        processRemark: this.submitText
      })
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '提交成功'
        })
        this.submitVisible = false
        this.$router.go(-1)
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    // 审批接口 （除了招商员之外的其他角色）
    async approvalFun () {
      if (this.approved === undefined) {
        return Message({
          message: '请填写审批结果',
          type: 'warning'
        })
      }
      let res = await addContractApprove({
        approved: this.approved,
        contractNumber: this.contractNumber,
        processRemark: this.approvalText
      })
      if (res.code === 0) {
        Message({
          message: '提交审批成功',
          type: 'success'
        })
        this.submitVisible = false
        this.$router.go(-1)
      } else {
        Message({
          message: res.message,
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
  }
  .table{
    margin-top: .3rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.8rem;
    .searchList{
    }
    .paginationBody{
      margin-top: .1rem;
    }
  }
  .btnDiv{
    height: .7rem;
    margin-left: .5rem;
    margin-top: .4rem;
  }
</style>
